// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Slider.rc-slider-vertical {
  padding: 0 4px;
  margin: 8px 0;
}
.Slider.rc-slider:not(.rc-slider-vertical) {
  margin-right: 8px;
  margin-left: 8px;
}
.Slider.rc-slider .rc-slider-handle,
.Slider.rc-slider-vertical .rc-slider-handle {
  width: 16px;
  height: 16px;
  margin-left: -5.5px;
  border: none;
  background-color: var(--gray-50);
  opacity: 1;
}
.Slider.rc-slider:not(.rc-slider-vertical) .rc-slider-handle {
  transform: translateX(0) !important;
}
.Slider
  .rc-slider-handle.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
  box-shadow: none;
}

.Slider .rc-slider-handle:active {
  width: 16px;
  height: 16px;
  margin-left: -5.5px;
  box-shadow: none;
}

.Slider.rc-slider .rc-slider-rail {
  background-color: var(--gray-950);
  height: 6px;
}

.Slider.rc-slider-vertical .rc-slider-rail {
  background-color: var(--gray-950);
  width: 6px;
  height: 100%;
}
.Slider.rc-slider .rc-slider-track {
  background-color: var(--gray-50);
  height: 6px;
}

.Slider.rc-slider-vertical .rc-slider-track {
  background-color: var(--gray-50);
  width: 6px;
}
.Slider-gradient.Slider.rc-slider .rc-slider-track {
  background-image: linear-gradient(to right, var(--brand-purple), var(--brand-pink));
}

.Slider-gradient.Slider.rc-slider-vertical .rc-slider-track {
  background-image: linear-gradient(to top, var(--brand-purple), var(--brand-pink));
}
.Slider.rc-slider-vertical .rc-slider-track {
  left: 4px;
}

.Slider.rc-slider.rc-slider-disabled {
  background-color: transparent;
}
.Slider.rc-slider.rc-slider-disabled .rc-slider-track,
.Slider.rc-slider.rc-slider-disabled .rc-slider-rail {
  opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/slider/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,mCAAmC;AACrC;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,UAAU;EACV,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,mFAAmF;AACrF;;AAEA;EACE,iFAAiF;AACnF;AACA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;AACA;;EAEE,YAAY;AACd","sourcesContent":[".Slider.rc-slider-vertical {\n  padding: 0 4px;\n  margin: 8px 0;\n}\n.Slider.rc-slider:not(.rc-slider-vertical) {\n  margin-right: 8px;\n  margin-left: 8px;\n}\n.Slider.rc-slider .rc-slider-handle,\n.Slider.rc-slider-vertical .rc-slider-handle {\n  width: 16px;\n  height: 16px;\n  margin-left: -5.5px;\n  border: none;\n  background-color: var(--gray-50);\n  opacity: 1;\n}\n.Slider.rc-slider:not(.rc-slider-vertical) .rc-slider-handle {\n  transform: translateX(0) !important;\n}\n.Slider\n  .rc-slider-handle.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n  box-shadow: none;\n}\n\n.Slider .rc-slider-handle:active {\n  width: 16px;\n  height: 16px;\n  margin-left: -5.5px;\n  box-shadow: none;\n}\n\n.Slider.rc-slider .rc-slider-rail {\n  background-color: var(--gray-950);\n  height: 6px;\n}\n\n.Slider.rc-slider-vertical .rc-slider-rail {\n  background-color: var(--gray-950);\n  width: 6px;\n  height: 100%;\n}\n.Slider.rc-slider .rc-slider-track {\n  background-color: var(--gray-50);\n  height: 6px;\n}\n\n.Slider.rc-slider-vertical .rc-slider-track {\n  background-color: var(--gray-50);\n  width: 6px;\n}\n.Slider-gradient.Slider.rc-slider .rc-slider-track {\n  background-image: linear-gradient(to right, var(--brand-purple), var(--brand-pink));\n}\n\n.Slider-gradient.Slider.rc-slider-vertical .rc-slider-track {\n  background-image: linear-gradient(to top, var(--brand-purple), var(--brand-pink));\n}\n.Slider.rc-slider-vertical .rc-slider-track {\n  left: 4px;\n}\n\n.Slider.rc-slider.rc-slider-disabled {\n  background-color: transparent;\n}\n.Slider.rc-slider.rc-slider-disabled .rc-slider-track,\n.Slider.rc-slider.rc-slider-disabled .rc-slider-rail {\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
